<script lang="ts" setup>
/* eslint vue/no-v-html: "off" */
import type { UseMarkOptions } from "~/composables/useMark";

interface MarkProps {
    text?: string;
    keyword?: string;
    class?: any;
    options?: Partial<UseMarkOptions>;
}

const props = withDefaults(defineProps<MarkProps>(), {
    text: "",
    keyword: "",
    options: () => ({}),
});

const textRef = ref<MarkProps["text"]>(props.text);
const keywordRef = ref<MarkProps["keyword"]>(props.keyword);
const optionsRef = ref<MarkProps["options"]>(props.options);

watch(
    () => props.text,
    (to) => (textRef.value = to),
);
watch(
    () => props.keyword,
    (to) => (keywordRef.value = to),
);
watch(
    () => props.options,
    (to) => (optionsRef.value = to),
);

const mark = useMark(textRef, keywordRef, optionsRef);
</script>

<template>
    <slot :text="text" :keyword="keyword" :output="mark">
        <span v-html="mark" :class="props.class" />
    </slot>
</template>

<style>
mark {
    @apply bg-primary-500 rounded-sm;
}
</style>
